/**
 * Pure work order filtering by the shared TopNavBar filters
 * (inspectionViewMode / selectedPropertyList / favoritedPropertyIds).
 *
 * Mirrors WorkOrdersScreen.applyWorkOrderFiltering so any Mike-side filter
 * matches what the user sees in the work orders table.
 */

const parsePropertyListUuids = (selectedPropertyList) => {
  if (!selectedPropertyList || !selectedPropertyList.properties_list) return null;
  try {
    const parsed = JSON.parse(selectedPropertyList.properties_list);
    return Array.isArray(parsed) ? parsed : null;
  } catch (e) {
    return null;
  }
};

export const applyWorkOrderFiltering = (workOrders, { viewMode, selectedPropertyList, favoritedPropertyIds } = {}) => {
  const wos = workOrders || [];

  if (viewMode === 'favorited') {
    const favoriteUuids = favoritedPropertyIds || [];
    if (favoriteUuids.length === 0) return [];
    return wos.filter(wo => !!wo.property_uuid && favoriteUuids.includes(wo.property_uuid));
  }

  if (viewMode === 'propertyList') {
    const propertyUuids = parsePropertyListUuids(selectedPropertyList);
    if (!propertyUuids || propertyUuids.length === 0) return [];
    return wos.filter(wo => !!wo.property_uuid && propertyUuids.includes(wo.property_uuid));
  }

  return wos;
};

export const getFilterHash = ({ inspectionViewMode, selectedPropertyList, favoritedPropertyIds } = {}) => {
  const sortedFavorites = [...(favoritedPropertyIds || [])].sort().join(',');
  return JSON.stringify({
    viewMode: inspectionViewMode || null,
    listUuid: selectedPropertyList?.uuid || null,
    favorites: sortedFavorites
  });
};

export const getPropertyListSize = (selectedPropertyList) => {
  const ids = parsePropertyListUuids(selectedPropertyList);
  return ids === null ? null : ids.length;
};
